import type { AppState } from '@app/react/reducer';

export const selectPreviewMode = (state: AppState): boolean => state.uiPartsView.previewMode;
